<template>
    <div id="add-fonts" class="modal inmodal fade" role="dialog" aria-hidden="true" data-backdrop="static" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header-dialog-painting">
                    <h2 class="modal-title">{{ translations.title }}</h2>
                </div>
                <div class="modal-body scrollBox" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <loading v-if="saving" :loading="saving"/>
                    <template v-if="overQuota === true">
                        <div class="alert alert-danger font-bold" v-html="translations.overQuota"></div>
                    </template>
                    <template v-else>
                        <div class="wizard-notifications">
                            <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
                                {{ translations.error }}
                                <ul>
                                    <li v-for="error in errors">
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <dropzone :id="id" :global="global" @uploadedFile="addUploadedFile"/>

                        <titles :files="files" :global="global"></titles>
                    </template>
                </div>
                <div class="modal-footer">
                    <div aria-label="uploaded file count" class="inline m-r-sm file-count">{{ uploadedFilesCount }}</div>
                    <div class="btn-group m-r-sm">
                        <template v-if="approvePrivilege === '1'">
                            <dialog-button
                                class="mr-1"
                                :disabled="!canSave"
                                :color="'primary'"
                                @click="saveWrapper(updateApprove, updatePublish)"
                            >
                                {{ translations.save }}
                            </dialog-button>
                            <button type="button" class="btn btn-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu dropdown-white">
                                <li>
                                    <a @click.stop="cycleUpdateApprove()">
                                        <div class="row">
                                            <div class="col-md-3"><i :class="[updateApprove === 0 ? 'fa-square-minus' : (updateApprove === 1 ? 'fa-square-check' : 'fa-square'), 'fa-regular']"></i></div>
                                            <div class="col-md-6 no-padding"> {{ translations.approve }} </div>
                                            <div class="col-md-3">
                                                <span :data-balloon="updateApprove === 0 ? translations.autoKeepApproved : (updateApprove === 1 ? translations.autoApprove : translations.autoDisapprove)"
                                                      data-balloon-pos="up-right"
                                                      data-balloon-length="large">
                                                    <i class="fa-light fa-circle-question cursor-pointer"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li v-if="publishPrivilege === '1'">
                                    <a @click.stop="cycleUpdatePublish()">
                                        <div class="row">
                                            <div class="col-md-3"><i :class="[updatePublish === 0 ? 'fa-square' : 'fa-square-check', 'fa-regular']"></i></div>
                                            <div class="col-md-6 no-padding"> {{ translations.publish }} </div>
                                            <div class="col-md-3">
                                                <span :data-balloon="updatePublish === 0 ? translations.autoNotPublish : translations.autoPublish"
                                                      data-balloon-pos="up-right"
                                                      data-balloon-length="large">
                                                    <i class="fa-light fa-circle-question cursor-pointer"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </template>
                        <template v-else>
                            <dialog-button
                                class="mr-1"
                                :disabled="!canSave || files.length === 0 || saving"
                                :color="'primary'"
                                @click="saveWrapper(-1, 0)"
                            >
                                {{ translations.save }}
                            </dialog-button>
                        </template>
                    </div>
                    <dialog-button
                        @click="cancelUpload"
                        :color="'secondary'"
                    >
                        {{ translations.cancel }}
                    </dialog-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import modalMixin from "../../common/modal-mixin";
import toaster from "../../common/toaster";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
import {ERRORS} from "./fontVariables.js";
import DialogButton from "../../dialog/components/dialog-button.vue";
import Loading from "../../common/loading.vue";

export default {
    mixins: [
        modalMixin,
    ],
    props: [
        'id',
        'fonts',
        'approvePrivilege',
        'publishPrivilege',
        'overQuota',
    ],
    components: {
        Loading,
        DialogButton,
        DialogActionbar,
        dropzone: require('./add/fonts-dropzone.vue').default,
        titles: require('./add/fonts-titles.vue').default,
    },
    data: function () {
        return {
            files: [],
            animateElements: 'input, label, .file-manager, img, .chosen-container',
            errors: {},
            saving: false,
            modalName: 'add-fonts',
            global: false,
            updatePublish: 0,
            updateApprove: -1,
            visible: true,
            canSave: true,
        }
    },
    computed: {
        uploadedFilesCount: function () {
            if (this.files.length) {
                return Lang.langGet(":count files uploaded", {
                    'count': this.files.filter(file => {
                        return !(file.file_duplicate_checksum === true && file.use === false) &&
                            !(file.file_overwrite === 0 && file.file_duplicate_system === true && file.file_duplicate_upload === false);
                    }).length
                })
            } else {
                return '';
            }
        },
        translations() {
            return {
                title: Lang.langGet("Add new font"),
                error: Lang.langGet("Failed to save fonts:"),
                cancel: Lang.langGet("Cancel"),
                save: Lang.langGet("Save"),
                overQuota: Lang.langGet("The project is over the HDD quota.<br>Please delete some files, before you add new ones."),
                approve: Lang.langGet("Approve"),
                publish: Lang.langGet("Publish"),
                autoApprove: Lang.langGet("The modified content gets approved in all layers."),
                autoKeepApproved: Lang.langGet("Approved state of layer elements is not changed."),
                autoDisapprove: Lang.langGet("Layer elements that contain the modified content get disapproved."),
                autoPublish: Lang.langGet("Layers that contain the modified content get published to the relevant screens."),
                autoNotPublish: Lang.langGet("Layer elements do not get published."),
            }
        }
    },
    methods: {
        removeErrors(files = this.files) {
            files.forEach(file => {
                file.error = null;
            });
        },
        validateFiles(fontsToBeUploaded = this.files) {
            this.removeErrors();

            fontsToBeUploaded.forEach((font, index) => {
                const alreadyExists = fontsToBeUploaded.some(
                    (existingFont, otherIndex) => {
                        return (
                            existingFont.style === font.style &&
                            existingFont.weight === font.weight &&
                            existingFont.family === font.family &&
                            otherIndex !== index
                        );
                    }
                );
                if (alreadyExists) font.error = ERRORS.DUPLICATE_SETTINGS_IN_UPLOAD;
            });

            fontsToBeUploaded.forEach((font, index) => {
                const alreadyExists = fontsToBeUploaded.some(
                    (otherFont, otherIndex) => otherFont.file_name === font.file_name && otherIndex !== index
                );
                if (alreadyExists) font.error = ERRORS.DUPLICATE_NAME_IN_UPLOAD;
            });

            fontsToBeUploaded.forEach(font => {
                const alreadyExists = this.fonts.some(
                    existingFont => {
                        return (
                            existingFont.style === font.style &&
                            existingFont.weight === font.weight &&
                            existingFont.family === font.family
                        );
                    }
                );
                if (alreadyExists) font.error = ERRORS.DUPLICATE_SETTINGS;
            });

            fontsToBeUploaded.forEach(font => {
                const alreadyExists = this.fonts.some(existingFont => existingFont.file_name === font.file_name);
                if (alreadyExists) font.error = ERRORS.DUPLICATE_NAME;
            });

            this.canSave = !fontsToBeUploaded.some(font => font.error);
        },
        reset: function (global) {
            _.extend(this.$data, this.$options.data());
            this.global = global;
            $(this.$el).find(this.animateElements).removeClass('animated');
            if (this.publishPrivilege && this.approvePrivilege) {
                this.updatePublish = parseInt(localStorage.getItem("fonts-publish-" + Laravel.activeProject) ?? 1);
            }
            if (this.approvePrivilege) {
                this.updateApprove = parseInt(localStorage.getItem("fonts-approve-" + Laravel.activeProject) ?? 1);
            }
        },
        saveWrapper: function (approve=0, publish=0) {
            if (this.saving === true) {
                return;
            }

            this.errors = {};
            this.saving = true;
            let data = {
                approve: approve,
                publish: publish
            };

            if (data.publish && !localStorage.getItem("fonts-autopublish-confirm-" + Laravel.activeProject)) {
                EaseEventBus.fire('showAutopublishWarning', {data: data, type: 'fonts', task: 'Save', id: 'add-fonts'});
            } else {
                this.save(data);
            }
        },
        save: function (data) {
            axios.post('/administration/font/add', {
                files: this.files,
                approve: data.approve,
                publish: data.publish
            }).then((response) => {
                this.saving = false;

                if (response) {
                    toaster.success(Lang.langGet("Added :count fonts.", {count: response.data}));
                }

                EaseEventBus.fire('hideModal', this.modalName);
                EaseEventBus.fire('updateFontsData');
                this.visible = false;
            }).catch((error) => {
                this.saving = false;

                if (error.response.status === 401) {
                    window.location = '/login';
                } else if (error.response.status === 422) {
                    let tmpErrors = {};

                    if (error.response.data.files !== undefined) {
                        this.files = Object.values(JSON.parse(JSON.stringify(error.response.data.files)));
                        let count = error.response.data.count;
                        if (count) {
                            toaster.success(Lang.langGet("Added :count fonts.", {count: count}));
                        }
                    }

                    for (let key in error.response.data.errors) {
                        tmpErrors[key] = error.response.data.errors[key];
                    }

                    this.errors = _.extend({}, this.errors, tmpErrors);
                } else {
                    this.errors = _.extend({}, this.errors, error.response.data.data);
                }
            });
        },
        addUploadedFile: function (file) {
            file.file_overwrite = 0;
            file.file_duplicate_upload = false;
            file.title_duplicate_upload = false;
            this.files.push(file);
        },
        cancelUpload: function () {
            axios.post('/administration/font/upload/cancel', {
                files: this.files
            });
            EaseEventBus.fire('cancelUpload');
            EaseEventBus.fire('hideModal', 'add-fonts');
            this.visible = false;

            if (this.add === '1') {
                window.location = this.backUrl;
            }
        },
        cycleUpdatePublish: function () {
            this.updatePublish = (parseInt(this.updatePublish) + 1) % 2 || 0;
            localStorage.setItem("fonts-publish-" + Laravel.activeProject, this.updatePublish);
        },
        cycleUpdateApprove: function () {
            this.updateApprove = (parseInt(this.updateApprove) + 1) % 3 || 0;
            this.updateApprove = this.updateApprove === 2 ? -1 : this.updateApprove;
            localStorage.setItem("fonts-approve-" + Laravel.activeProject, this.updateApprove);
        }
    },
    watch: {
        files: {
            handler () {
                this.validateFiles();
            }, deep: true
        }
    },
    mounted() {
        EaseEventBus.listen('showAddFontsModal', (global) => {
            this.reset(global);
            $(this.$el).find(this.animateElements).addClass('animated');
            EaseEventBus.fire('showModal', this.modalName);
        });

        EaseEventBus.listen('updateProceed', (data) => {
            if (data.type === 'fonts' && data.task === 'Save' && data.id === 'add-fonts') {
                if (data.proceed) {
                    this.save(data.data);
                } else {
                    this.saving = false;
                }
            }
        });
    }
}
</script>
